<template>
    <div class="amount_card" :class="isActiveAmount ? 'active_card' : ''" @click="handleCardClick">
           {{ formatCurrency(props.amount as any) }}
        <div v-if="isTopupVisible" class="topPercentage" :class="isActiveAmount ? 'activeLabel' : 'inactiveLabel'">
            <span class="item-span">{{ props.giftRatio }}%</span>
        </div>
    </div>
</template>

<script setup lang="ts">
import { formatCurrency } from '@/utils/commonFunction';


const props = defineProps({
    amount: {
        type: Number,
    },
    isActiveAmount: {
        type: Boolean,
        default: () => false
    },
    isTopupVisible: {
        type: Boolean,
        default: () => false
    },
    giftRatio: {
        type: Number,
    }
})
const emits = defineEmits(['handleCardClick'])

const handleCardClick = () => {
    emits('handleCardClick')
}

</script>
<style scoped>
.amount_card {
    position: relative;
    border-radius: 5px;
    color: #FFF;
    background-color: rgb(0, 86, 85);
    padding: 12px 10px;
    min-width: 80px;     
    flex: 0 0 auto;
    text-align: center;
    font-size: 19px;
    overflow: hidden;
    font-weight: 700;
}

.active_card {
    font-weight: bold;
    border: 2px solid #0DB0AE;
    background-image: linear-gradient(180deg,rgba(0,0,0,0) 16.59%,var(--ep-color-background-fill-glow-primary-opacity-40, rgba(58, 140, 227, .4)) 110.34%),var(--ep-color-background-fill-surface-raised-L2, #1A1F30);
    color: #FFFF;

}

.activeLabel {
    background: #0DB0AE;
    color: #FFFF;
    font-weight: 600;
}

.inactiveLabel {
    background: rgba(0, 0, 0, 0.15);
    color: rgba(255, 255, 255, 0.85);
}

.topPercentage {
    position: absolute;
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
    width: 72px;
    height: 27px;
    top: -2px;
    right: -28px;
    transform: rotate(45deg);
    font-size: 9px;
}

@media (max-width: 360px) {
  .amount_card {
    padding: 8px 6px;
    font-size: 14px;
    min-width: unset;
    border-radius: 4px;
  }

  .active_card {
    border-width: 1.5px;
  }

  .topPercentage {
    width: 50px;
    height: 18px;
    right: -19px;
    font-size: 8px;
  }

  
}

.item-span {
    top: 10px;
    left: 1px;
}
</style>